import React, { Fragment } from 'react';
import { Grid } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { isMobile } from 'react-device-detect';
// placeholder for DataRoomHeader (asset switcher, Technical Specification, Inventory) while the asset list loads; same box and spacer so the page doesn't shift
const DataRoomHeaderLoader = () => {
  return (
    <Fragment>
      <div className="data-room-head">
        <Grid container alignItems="center" spacing={isMobile ? 2 : 3}>
          <Grid item xs={6} sm={6} md={6}>
            <ul className="list-inline flex-centered asset-switcher">
              <li className="list-inline-item">
                <Skeleton variant="text" animation="wave" height={32} width="100%" />
              </li>
              {isMobile ? null :
                <li className="list-inline-item link-export flex-centered">
                  <Skeleton variant="rect" animation="wave" width={18} height={18} style={{ marginRight: '6px', borderRadius: '2px' }} />
                  <Skeleton variant="text" animation="wave" width={140} height={20} />
                </li>
              }
              {isMobile ? null :
                <li className="list-inline-item link-export flex-centered">
                  <Skeleton variant="rect" animation="wave" width={18} height={18} style={{ marginRight: '6px', borderRadius: '2px' }} />
                  <Skeleton variant="text" animation="wave" width={70} height={20} />
                </li>
              }
            </ul>
          </Grid>
          <Grid item xs={6} sm={6} md={6}>
            <ul className="list-inline more-action-cta flex-centered">
              {isMobile ? null :
                <li className="list-inline-item">
                  <Skeleton variant="circle" animation="wave" width={28} height={28} />
                </li>
              }
              <li className="list-inline-item">
                <Skeleton variant="rect" animation="wave" width={110} height={30} style={{ borderRadius: '4px' }} />
              </li>
            </ul>
          </Grid>
        </Grid>
      </div>
      <div style={isMobile ? { height: 'auto' } : { height: '42px' }}></div>
    </Fragment>
  )
}
export default DataRoomHeaderLoader;
